import { Injectable } from '@angular/core';
import { ApplicationSettings } from '../../shared/models/application.settings';
import { SettingsLoaderService } from './settings.loader.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  //Deprecated do not use this value anymore, use getPageableSize() instead
  public static pageSizeForPagination: number = 150;
  private configuration: ApplicationSettings;

  constructor(private settingsLoaderService: SettingsLoaderService) {}

  getBffEndpoint(): string {
    return this.settingsLoaderService.configuration.bffEndpoint;
  }

  getKeyCloakUrl(): string {
    return this.settingsLoaderService.configuration.keyCloakUlr;
  }

  isProduction(): boolean {
    return this.settingsLoaderService.configuration.isProduction;
  }

  isTest(): boolean {
    return this.settingsLoaderService.configuration.isTest;
  }
  getPageableSize(): number {
    return this.settingsLoaderService.configuration.pageableSize ? this.settingsLoaderService.configuration.pageableSize : 150;
  }

  isLocal(): boolean {
    return !this.isProduction() && !this.isTest();
  }

  getCaseManagementSystemURL(): string {
    return this.settingsLoaderService.configuration.caseManagementSystemEndpoint;
  }

  getAtlasApiServiceEndpoint(): string {
    return this.settingsLoaderService.configuration.atlasApiServiceEndpoint;
  }

  getAtlasAccessRole(): string {
    return this.settingsLoaderService.configuration.atlasAccessRole || '';
  }

  getGoogleTimezoneAPIURL() : string {
    return this.settingsLoaderService.configuration.googleTimezoneAPIURL;
  }

  getGoogleAPIKey() : string {
    return this.settingsLoaderService.configuration.googleAPIKey;
  }

  isSsoDisabled(): boolean {
    return this.settingsLoaderService.configuration.ssoDisabled;
  }

  getProviderURL(): string {
    return this.settingsLoaderService.configuration.providerEndpoint;
  }

  isReserveSuggestionEnabled(): boolean {
    return this.settingsLoaderService.configuration.reserveSuggestionEnabled;
  }

  getOpenCasesMaxCount(): number {
    return !!this.settingsLoaderService.configuration.openCasesMaxCount ? this.settingsLoaderService.configuration.openCasesMaxCount : 15;
  }

  getOpenCasesWarningThreshold(): number {
    return !!this.settingsLoaderService.configuration.openCasesWarningThreshold ? this.settingsLoaderService.configuration.openCasesWarningThreshold : 10;
  }

  isZoomed(): boolean {
    return localStorage.getItem('zoomed') === 'true';
  }

  getFeature(): any {
    return this.settingsLoaderService.configuration.feature ? this.settingsLoaderService.configuration.feature : {};
  }

  getZoomFactor(): number {
    return this.isZoomed() ? 0.9091 : 1;
  }

  isRecoveryPaymentMovementAvailable(): boolean {
    return this.settingsLoaderService.configuration.isRecoveryPaymentMovementEnabled;
  }
}
